import { render, staticRenderFns } from "./BySegment.vue?vue&type=template&id=6b13787e"
import script from "./BySegment.vue?vue&type=script&lang=js"
export * from "./BySegment.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports